import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authFetch } from '../utils/apiHelper';
import { API_URL } from '../config';
import Scene from './Scene';

// Public entry point for a "Shares" link (/s/:shareId) — the only URL a
// visitor ever sees or needs. Resolves the token to a modelId via the
// unauthenticated getShare endpoint, stashes it in sessionStorage
// (authFetch then forwards the token on every downstream call the viewer
// makes), and renders <Scene /> directly in place — no redirect, no URL
// change, ever. Scene never even mounts (so no loading UI flashes) until
// the token's confirmed valid. An invalid/expired token lands on
// /link-expired instead.
const SharedScene = () => {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    authFetch(`${API_URL}?getShare=true&id=${shareId}`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        sessionStorage.setItem('shareToken', shareId);
        sessionStorage.setItem('shareModelId', data.modelId);
        // Set before rendering Scene so the shared-view CSS (styles.css) is
        // already active the instant the capture button mounts — doing this
        // later, e.g. once SceneHandler.js's init reaches it, left a brief
        // window where the button rendered undimmed.
        document.body.classList.add('shared-view');
        setVerified(true);
      })
      .catch(() => navigate('/link-expired', { replace: true }));
  }, [shareId, navigate]);

  if (!verified) {
    return (
      <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#20252b' }} />
    );
  }

  return <Scene />;
};

export default SharedScene;
